<template>
  <q-page padding>
    <div class="row no-print">
      <div class="col-12">
        <q-card>
          <q-card-section class="text-h6">
            Pedidos
          </q-card-section>
          <q-separator />
          <q-card-section>
            <q-table 
              :data="pedidos"
              :grid="true"
              :loading="loading"
            >
              <template v-slot:item="props">
                <div class="col-12">
                  <q-list dense>
                    <q-item class="q-mb-sm q-mt-sm">
                      <q-item-section>
                        <q-item-label lines="1">Número: {{props.row.numPedido}}</q-item-label>
                        <q-item-label caption lines="1">Emissão: {{props.row.dataEmissao | date}}</q-item-label>
                        <q-item-label caption lines="1">Indústria: {{props.row.nomeFantasiaInd}}</q-item-label>
                        <q-item-label caption lines="1">Cliente: {{props.row.nomeFantasia || props.row.nome}}</q-item-label>
                      </q-item-section>
                      <q-item-section side top>
                        <q-item-label>
                          <q-btn-dropdown color="primary" label="Opções" size="sm" dense>
                            <q-list>
                              <q-item clickable v-close-popup @click="openModalExtrato(props.row)">
                                <q-item-section>
                                  <q-item-label>Extrato</q-item-label>
                                </q-item-section>
                              </q-item>

                              <q-item clickable v-close-popup @click="openModalProgramacao(props.row)">
                                <q-item-section>
                                  <q-item-label>Programação</q-item-label>
                                </q-item-section>
                              </q-item>
                            </q-list>
                          </q-btn-dropdown>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                    <q-separator />
                  </q-list>
                </div>
              </template>
            </q-table>
          </q-card-section>
        </q-card>
      </div>
    </div>
    
    <q-dialog :value="true" v-if="modalExtrato" persistent maximized>
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Extrato do pedido {{pedidoSelecionado.numPedido}}</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="modalExtrato = false" />
        </q-card-section>
        <q-card-section>
          <grid-extrato :pedido="pedidoSelecionado" />
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog :value="true" v-if="modalProgramacao" persistent maximized>
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Programação do pedido {{pedidoSelecionado.numPedido}}</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="modalProgramacao = false" />
        </q-card-section>
        <q-card-section>
          <grid-programacao :pedido="pedidoSelecionado" />
        </q-card-section>
      </q-card>
    </q-dialog>

  </q-page>
</template>

<script>
import { getPedidosCliente } from '../../services/clientes'
import GridExtrato from './GridExtrato'
import GridProgramacao from './GridProgramacao'
export default {
  data () {
    return {
      perPage: 10,
      currentPage: 1,
      pedidos: [],
      loading: false,
      pedidoSelecionado: '',
      modalExtrato: false,
      modalProgramacao: false
    }
  },
  mounted() {
    if (!this.clienteSelecionado.codCliente) {
      this.$router.push({ name: 'Main' })
    }
    this.getPedidos()
  },
  methods: {
    async getPedidos () {
      try {
        this.loading = true
        this.pedidos = await getPedidosCliente(this.clienteSelecionado.codCliente)
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: error.message
        })
      } finally {
        this.loading = false
      }
    },

    openModalExtrato (pedido) {
      this.pedidoSelecionado = pedido
      this.modalExtrato = true
    },

    openModalProgramacao (pedido) {
      this.pedidoSelecionado = pedido
      this.modalProgramacao = true
    }
  },
  computed: {
    clienteSelecionado () {
      return this.$store.getters.getCliente
    }
  },
  components: {
    GridExtrato,
    GridProgramacao
  }
}
</script>